import React from "react";
import { Col, Divider, Input, Row, Form, Select } from "antd";
import { MailOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

import { patientFields } from "../fieldNames";
import { DobFormItem, FormDividerText, InputPhoneWithPhoneTypeAddon } from "../../../../../components";
import FormItem from "../../../../../../../FormItem";
import { emailInputRules, onlyWhitespacesRule, zipInputRules } from "../../../../../utils";
import { GRAY_500 } from "../../../../../../../../constant/colors";
import { phoneNumberLengthRegEx } from "../../../../../../../../utils/formValidation";
import { SingleSelect } from "../../../../../../../customComponent/CustomSelect";
import { States as STATES } from "../../../../../../../../constant/states";
import { GenderFormItem } from "../../../../../GenderFormItem";

const { Option } = Select;

export const PfizerCopayIvPatient = () => {
  const { t } = useTranslation();
  const form = Form.useFormInstance();
  const gender = Form.useWatch(patientFields.gender, form);

  return (
    <>
      <div id="enrollment-form-copay-iv-patient-information-anchor" />
      <Divider orientation="left" orientationMargin="0" style={{ color: GRAY_500 }}>
        <FormDividerText>{t("application_form_editor.pfizer.copay.iv.patient.labels.header")}</FormDividerText>
      </Divider>
      <Form.Item name={patientFields.id} hidden />
      <Row gutter={16}>
        <Col span={8}>
          <FormItem
            name={patientFields.firstName}
            label={t("application_form_editor.pfizer.copay.iv.patient.labels.first_name")}
            rules={[{ required: true }, onlyWhitespacesRule]}
          >
            <Input placeholder={t("application_form_editor.pfizer.copay.iv.patient.placeholders.first_name")} />
          </FormItem>
        </Col>
        <Col span={8}>
          <FormItem
            rules={[{ required: true }, onlyWhitespacesRule]}
            name={patientFields.lastName}
            label={t("application_form_editor.pfizer.copay.iv.patient.labels.last_name")}
          >
            <Input placeholder={t("application_form_editor.pfizer.copay.iv.patient.placeholders.last_name")} />
          </FormItem>
        </Col>
        <Col span={8}>
          <DobFormItem
            required
            name={patientFields.dob}
            label={t("application_form_editor.pfizer.copay.iv.patient.labels.dob")}
          />
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={8}>
          <GenderFormItem
            thirdOption={t("application_form_editor.pfizer.copay.iv.patient.gender_other")}
            width={155}
            formItemName={patientFields.gender}
            label={t("application_form_editor.pfizer.copay.iv.patient.labels.gender")}
            showError={!gender}
            showThirdOption={false}
          />
        </Col>
        <Col span={8}>
          <FormItem
            rules={[{ required: true }, onlyWhitespacesRule]}
            name={patientFields.address}
            label={t("application_form_editor.pfizer.copay.iv.patient.labels.street_address")}
          >
            <Input placeholder={t("application_form_editor.pfizer.copay.iv.patient.placeholders.street_address")} />
          </FormItem>
        </Col>
        <Col span={8}>
          <FormItem
            name={patientFields.city}
            label={t("application_form_editor.pfizer.copay.iv.patient.labels.city")}
            rules={[{ required: true }, onlyWhitespacesRule]}
          >
            <Input placeholder={t("application_form_editor.pfizer.copay.iv.patient.placeholders.city")} />
          </FormItem>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={6}>
          <FormItem
            rules={[{ required: true }]}
            name={patientFields.state}
            label={t("application_form_editor.pfizer.copay.iv.patient.labels.state")}
          >
            <SingleSelect
              useCommonStyle={false}
              bordered={true}
              placeholder={t("application_form_editor.pfizer.copay.iv.patient.placeholders.state")}
            >
              {Object.values(STATES).map((state, index) => (
                <Option key={index} value={state.code}>
                  {state.name}
                </Option>
              ))}
            </SingleSelect>
          </FormItem>
        </Col>
        <Col span={6}>
          <FormItem
            rules={[{ required: true }, ...zipInputRules]}
            name={patientFields.zip}
            label={t("application_form_editor.pfizer.copay.iv.patient.labels.zip_code")}
          >
            <Input
              maxLength={5}
              style={{ width: "100%" }}
              placeholder={t("application_form_editor.pfizer.copay.iv.patient.placeholders.zip_code")}
            />
          </FormItem>
        </Col>

        <Col span={6}>
          <FormItem
            rules={[{ required: true }, ...emailInputRules]}
            name={patientFields.email}
            label={t("application_form_editor.pfizer.copay.iv.patient.labels.email")}
          >
            <Input
              addonBefore={<MailOutlined />}
              placeholder={t("application_form_editor.pfizer.copay.iv.patient.placeholders.email")}
            />
          </FormItem>
        </Col>
        <Col span={6}>
          <FormItem
            rules={[{ required: true }, { pattern: phoneNumberLengthRegEx, message: "" }]}
            name={patientFields.phone}
            label={t("application_form_editor.pfizer.copay.iv.patient.labels.phone")}
          >
            <InputPhoneWithPhoneTypeAddon
              placeholder={t("application_form_editor.pfizer.copay.iv.patient.placeholders.phone")}
              typeName={patientFields.phoneType}
            />
          </FormItem>
        </Col>
      </Row>
    </>
  );
};
